/* global config */
import Vue from "vue";
import { fetchWithBackoff } from "../../utils/fetchWithBackoff";

const SmartORSettingsAPIService = class extends Vue {
  _DEBUG = false;

  constructor() {
    super();
    if (this._DEBUG) {
      this.debugMessage("BOOTSTRAPPED SMART OR SETTINGS API SERVICE");
    }
  }

  debugMessage(message) {
    return message;
  }

  /**
   * Fetch Smart OR settings for a location.
   * API: GET /tenants/:tenant/locations/:locationId/settings
   */
  async getSmartORSettings(tenant, facilityId) {
    if (!tenant || !facilityId || !config) return;

    const claims = await this.$auth.getIdTokenClaims();
    const id_token = claims.__raw;
    if (!id_token) return;

    const url = `${config.SMARTOR_SERVICE}/tenants/${tenant}/locations/${facilityId}/settings`;
    const request = new Request(url, {
      method: "GET",
      mode: "cors",
      cache: "default",
      withCredentials: true,
      credentials: "include",
      headers: {
        Authorization: "Bearer " + id_token,
        "Content-Type": "application/json",
      },
    });

    return await fetchWithBackoff(request);
  }

  /**
   * Update Smart OR settings for a location.
   * APIs:
   * 1. PUT /tenants/:tenant/locations/:locationId/settings
   */
  async updateSmartORSettings(tenant, facilityId, message = {}) {
    if (!tenant || !facilityId || !config) {
      return;
    }

    const claims = await this.$auth.getIdTokenClaims();
    const id_token = claims.__raw;
    if (!id_token) {
      return;
    }

    const url = `${config.SMARTOR_SERVICE}/tenants/${tenant}/locations/${facilityId}/settings`;
    const payload = message.settings || message;

    const request = new Request(url, {
      method: "PUT",
      mode: "cors",
      cache: "default",
      withCredentials: true,
      credentials: "include",
      headers: {
        Authorization: "Bearer " + id_token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const settingsResult = await fetchWithBackoff(request);

    return settingsResult;
  }
};

if (!Vue.prototype.$SmartORSettingsAPIService) {
  Vue.prototype.$SmartORSettingsAPIService = new SmartORSettingsAPIService();
}

export default Vue.prototype.$SmartORSettingsAPIService;
